import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxFfmService } from '../../../ngx-ffm.service';

@Component({
  selector: 'lib-new-registration-dialog',
  templateUrl: './new-registration-dialog.component.html',
  styleUrls: ['./new-registration-dialog.component.scss']
})
export class NewRegistrationDialogComponent implements OnInit {

  dirName = '';
  filepath = '';
  errorMessage = '';
  error = false;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private ngxffmService: NgxFfmService,
    public dialogRef: MatDialogRef<NewRegistrationDialogComponent>) { }

  ngOnInit() {
    this.filepath = this.data;
  }

  async btnNewRegistry_Click() {
    this.ngxffmService.postRegistry(this.filepath, this.dirName).then(data => {
      if (data['error']) {
        this.errorMessage = data['error'];
        this.error = true;
      } else {
        this.errorMessage = '';
        this.error = false;
        this.dialogRef.close(data);
      }
    });

  }

}
